<template>
  <div>
    <p>{{ post.title.rendered }}</p>
  </div>
</template>
<script>
export default {
  name: 'PostElement',
  props: {
    title: String
  },
  data() {
    return {
      datos: ''
    };
  },
  async mounted() {
  }
};
</script>
<style>
</style>
